import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: BASE });

client.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("dscr_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const authApi = {
  register: (data) => client.post("/auth/register", data).then((r) => r.data),
  login: (email, password) => client.post("/auth/login", { email, password }).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  forgotPassword: (email) => client.post("/auth/forgot-password", { email }).then((r) => r.data),
  resetPassword: (token, password) => client.post("/auth/reset-password", { token, password }).then((r) => r.data),
  googleSession: (session_id) => client.post("/auth/google/session", { session_id }).then((r) => r.data),
};

export const dealsApi = {
  list: (params = {}) => client.get("/deals", { params }).then((r) => r.data),
  get: (id) => client.get(`/deals/${id}`).then((r) => r.data),
  create: (data) => client.post("/deals", data).then((r) => r.data),
  update: (id, data) => client.put(`/deals/${id}`, data).then((r) => r.data),
  toggleStatus: (id) => client.patch(`/deals/${id}/status`).then((r) => r.data),
  remove: (id) => client.delete(`/deals/${id}`).then((r) => r.data),
  emailSheet: (data) => client.post("/deals/email-sheet", data).then((r) => r.data),
};

export const subscribersApi = {
  subscribe: (data) => client.post("/subscribers", data).then((r) => r.data),
  list: () => client.get("/subscribers").then((r) => r.data),
  remove: (id) => client.delete(`/subscribers/${id}`).then((r) => r.data),
};

export const leadsApi = {
  createInquiry: (data) => client.post("/inquiries", data).then((r) => r.data),
  createLead: (data) => client.post("/leads", data).then((r) => r.data),
  createPartner: (data) => client.post("/partners", data).then((r) => r.data),
  submitDeal: (data) => client.post("/submit-deal", data).then((r) => r.data),
};

export const savedApi = {
  list: () => client.get("/saved").then((r) => r.data),
  save: (id) => client.post(`/saved/${id}`).then((r) => r.data),
  unsave: (id) => client.delete(`/saved/${id}`).then((r) => r.data),
};

export const meApi = {
  summary: () => client.get("/me/summary").then((r) => r.data),
};

export const contactsApi = {
  inquiries: () => client.get("/inquiries").then((r) => r.data),
  partners: () => client.get("/partners").then((r) => r.data),
  leads: () => client.get("/leads").then((r) => r.data),
  members: () => client.get("/users").then((r) => r.data),
  numberRequests: () => client.get("/calc-results").then((r) => r.data),
  appointments: () => client.get("/appointments").then((r) => r.data),
  dealSubmissions: () => client.get("/admin/deal-submissions").then((r) => r.data),
  addSubscriber: (data) => client.post("/admin/subscribers", data).then((r) => r.data),
};

export const templatesApi = {
  list: () => client.get("/templates").then((r) => r.data),
  create: (data) => client.post("/templates", data).then((r) => r.data),
  update: (id, data) => client.put(`/templates/${id}`, data).then((r) => r.data),
  remove: (id) => client.delete(`/templates/${id}`).then((r) => r.data),
};

export const campaignsApi = {
  send: (data) => client.post("/campaigns/send", data).then((r) => r.data),
  list: () => client.get("/campaigns").then((r) => r.data),
};

export const blogApi = {
  posts: () => client.get("/blog/posts").then((r) => r.data),
  latest: () => client.get("/blog/latest").then((r) => r.data),
  adminList: () => client.get("/admin/blog").then((r) => r.data),
  generate: () => client.post("/admin/blog/generate").then((r) => r.data),
  update: (id, data) => client.put(`/admin/blog/${id}`, data).then((r) => r.data),
  publish: (id) => client.post(`/admin/blog/${id}/publish`).then((r) => r.data),
  unpublish: (id) => client.post(`/admin/blog/${id}/unpublish`).then((r) => r.data),
  remove: (id) => client.delete(`/admin/blog/${id}`).then((r) => r.data),
};

export const toolsApi = {
  calculate: (data) => client.post("/calculate", data).then((r) => r.data),
  calcEmail: (data) => client.post("/calculate/email", data).then((r) => r.data),
  stats: () => client.get("/admin/stats").then((r) => r.data),
  sendDigest: () => client.post("/admin/send-digest").then((r) => r.data),
  sendNewDeals: (title) => client.post("/admin/digest/new-deals", null, { params: { title } }).then((r) => r.data),
};

export default client;
